module.exports = __webpack_public_path__ + "static/media/IMG_20201119_185336_936.72035bd2.jpg";